var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAim1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 67,
    viewBox: "0 0 43 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.22696 46.4424V32.9703C2.74728 31.9332 1 29.4823 1 26.6299V7.87012C1 4.07606 4.07475 1 7.86881 1H34.2925C38.0866 1 41.1614 4.07606 41.1614 7.87012V9.32837",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1614 13.9058V26.6298C41.1614 29.4822 39.4141 31.9331 36.9344 32.9702V60.7149C36.9344 63.634 34.5685 65.9999 31.6494 65.9999H10.512C7.5929 65.9999 5.22701 63.634 5.22701 60.7149V51.0198",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5115 33.5H31.6497",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.22701 24.4539V26.6301C5.22701 28.0897 6.41061 29.272 7.86885 29.272H34.2926C35.7508 29.272 36.9344 28.0897 36.9344 26.6301V7.87037C36.9344 6.41081 35.7508 5.22852 34.2926 5.22852H7.86885C6.41061 5.22852 5.22701 6.41081 5.22701 7.87037V19.8764",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3651 41.8232H15.796",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3651 57.6768H15.796",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1538 55.0343V44.4653",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0076 55.0343V44.4653",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1538 44.4651C14.613 44.4651 15.796 43.2822 15.796 41.8229C15.796 40.3636 14.613 39.1807 13.1538 39.1807C11.6945 39.1807 10.5115 40.3636 10.5115 41.8229C10.5115 43.2822 11.6945 44.4651 13.1538 44.4651Z",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0076 44.4651C30.4668 44.4651 31.6498 43.2822 31.6498 41.8229C31.6498 40.3636 30.4668 39.1807 29.0076 39.1807C27.5483 39.1807 26.3653 40.3636 26.3653 41.8229C26.3653 43.2822 27.5483 44.4651 29.0076 44.4651Z",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1538 60.3191C14.613 60.3191 15.796 59.1362 15.796 57.6769C15.796 56.2176 14.613 55.0347 13.1538 55.0347C11.6945 55.0347 10.5115 56.2176 10.5115 57.6769C10.5115 59.1362 11.6945 60.3191 13.1538 60.3191Z",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0076 60.3191C30.4668 60.3191 31.6498 59.1362 31.6498 57.6769C31.6498 56.2176 30.4668 55.0347 29.0076 55.0347C27.5483 55.0347 26.3653 56.2176 26.3653 57.6769C26.3653 59.1362 27.5483 60.3191 29.0076 60.3191Z",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8442 15.56C14.3382 15.2181 13.728 15.0186 13.0714 15.0186C11.3202 15.0186 9.90063 16.4381 9.90063 18.1893C9.90063 19.9405 11.3202 21.36 13.0714 21.36C13.7826 21.36 14.3676 21.1259 14.8116 20.7304C14.9034 20.6486 14.9893 20.5599 15.069 20.4649",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2611 21.36L29.119 21.3502C29.119 21.3502 29.3148 21.0494 31.3034 18.2081C31.7374 17.5604 31.997 17.1639 31.997 16.6137C31.997 15.7328 31.2827 15.0186 30.4018 15.0186C29.6266 15.0186 28.9805 15.5715 28.8365 16.3046",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9037 21.36C23.6548 21.36 25.0744 19.9405 25.0744 18.1893C25.0744 16.4381 23.6548 15.0186 21.9037 15.0186C20.1525 15.0186 18.7329 16.4381 18.7329 18.1893C18.7329 19.9405 20.1525 21.36 21.9037 21.36Z",
    stroke: "#005F1F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAim1);
export default __webpack_public_path__ + "static/media/aim_1.e326407e014f9bae0b78d67c1cdab1e4.svg";
export { ForwardRef as ReactComponent };